// extracted by mini-css-extract-plugin
module.exports = {"base":"ArticlesPage_base__2S0yu","Content":"ArticlesPage_Content__CZkls","AllTutorialsWrapper":"ArticlesPage_AllTutorialsWrapper__R8-Oo"};